import React, { useState } from "react";
import { Menu, MenuItem, IconButton, ListItemIcon, ListItemText } from "@mui/material";
import { ArrowsDownUp, UsersThree, Clock } from "@phosphor-icons/react";
import { SORT_OPTIONS } from "constants/sortMessagesOptions";

const SortMenuButton = ({ onSortChange }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelect = (option) => {
    onSortChange?.(option);
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton onClick={handleOpen} fontSize="small" color="secondary">
        <ArrowsDownUp />
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        slotProps={{
          paper: {
            elevation: 4,
            sx: {
              borderRadius: 2,
              minWidth: "227px",
            },
          },
        }}
      >
        <MenuItem
          onClick={() => handleSelect(SORT_OPTIONS.RECENT)}
          sx={{
            "& .MuiListItemIcon-root": {
              paddingRight: 0,
            },
          }}
        >
          <ListItemIcon>
            <Clock weight="duotone" />
          </ListItemIcon>
          <ListItemText primaryTypographyProps={{ variant: "body2" }}>Most Recent</ListItemText>
          <span style={{ fontSize: 12, color: "#999", marginLeft: 4 }}>(Default)</span>
        </MenuItem>
        <MenuItem
          onClick={() => handleSelect(SORT_OPTIONS.TEAM_MEMBER)}
          sx={{
            "& .MuiListItemIcon-root": {
              paddingRight: 0,
            },
          }}
        >
          <ListItemIcon>
            <UsersThree weight="duotone" />
          </ListItemIcon>
          <ListItemText primaryTypographyProps={{ variant: "body2" }}>Team Members</ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
};

export default SortMenuButton;
